import Navbar from '@/pages/home/components/Navbar';
import MeetTheTeam from '@/pages/home/components/MeetTheTeam';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const teamSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Our Team | Higher Standard Global',
  url: `${siteUrl}/team`,
  description:
    'Three individuals with a combined legacy of discretion, expertise, and results in premium property management. Identities shared only by introduction.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Our Team', item: `${siteUrl}/team` },
    ],
  },
  mainEntity: {
    '@type': 'Organization',
    name: 'Higher Standard Global',
    url: siteUrl,
    member: [
      { '@type': 'OrganizationRole', roleName: 'Principal' },
      { '@type': 'OrganizationRole', roleName: 'Principal' },
      { '@type': 'OrganizationRole', roleName: 'Principal' },
    ],
  },
};

export default function TeamPage() {
  useSEO({
    title: 'Our Team | Higher Standard Global — Property Management Principals',
    description:
      'Three principals with a combined legacy of discretion, expertise, and results in premium property management. Higher Standard Global — by introduction only.',
    keywords: 'property management team, real estate management principals, Higher Standard Global team, private property management',
    canonical: '/team',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={teamSchema} id="schema-team" />
      <Navbar />
      <PageHero
        eyebrow="The Principals"
        title="Our Team"
        subtitle="Three individuals. A combined legacy of discretion, expertise, and results. Their identities are shared only by introduction."
        imageUrl="https://public.readdy.ai/ai/img_res/dd16ad9383dbed585adef089e2b7daab.jpg"
        ctaLabel="Request an Introduction"
        ctaPath="/contact"
      />
      <PageTransition label="Leadership" />
      <MeetTheTeam />
      <PageCrossLink
        prev={{
          label: 'Property Types',
          eyebrow: 'Portfolio',
          description: 'The range of exceptional properties we are equipped to manage.',
          path: '/properties',
        }}
        next={{
          label: 'Contact',
          eyebrow: 'Begin the Conversation',
          description: 'Ready to discuss your property? We are ready to listen.',
          path: '/contact',
        }}
      />
      <Footer />
    </main>
  );
}
